export default __webpack_public_path__ + "static/media/teamJuli.5d9bf047.jpg";